/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M8 4.5V4.2C8 3.07989 8 2.51984 8.21799 2.09202C8.40973 1.71569 8.71569 1.40973 9.09202 1.21799C9.51984 1 10.0799 1 11.2 1H12.8C13.9201 1 14.4802 1 14.908 1.21799C15.2843 1.40973 15.5903 1.71569 15.782 2.09202C16 2.51984 16 3.07989 16 4.2V4.5M12 18C9.79086 18 8 16.2091 8 14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="3"
				y="4"
				width="18"
				height="18"
				rx="9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="3"
				y="4"
				width="18"
				height="18"
				rx="9"
				fill="currentColor"
			/>
			<path
				d="M8 4.5V4.2C8 3.07989 8 2.51984 8.21799 2.09202C8.40973 1.71569 8.71569 1.40973 9.09202 1.21799C9.51984 1 10.0799 1 11.2 1H12.8C13.9201 1 14.4802 1 14.908 1.21799C15.2843 1.40973 15.5903 1.71569 15.782 2.09202C16 2.51984 16 3.07989 16 4.2V4.5M12 18C9.79086 18 8 16.2091 8 14M12 22V22C16.9706 22 21 17.9706 21 13V13C21 8.02944 16.9706 4 12 4V4C7.02944 4 3 8.02944 3 13V13C3 17.9706 7.02944 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.1696 0.25H11.2H12.8H12.8304C13.3646 0.24999 13.8104 0.249981 14.1747 0.27974C14.5546 0.310778 14.9112 0.377889 15.2485 0.549733C15.7659 0.813385 16.1866 1.23408 16.4503 1.75153C16.6221 2.08879 16.6892 2.44545 16.7203 2.82533C16.75 3.18955 16.75 3.63538 16.75 4.16951V4.16955V4.2V4.48329C19.7331 6.1506 21.75 9.33976 21.75 13C21.75 18.3848 17.3848 22.75 12 22.75C6.61522 22.75 2.25 18.3848 2.25 13C2.25 9.33976 4.26692 6.1506 7.25 4.48329V4.2L7.25 4.16957V4.16955C7.24999 3.6354 7.24998 3.18956 7.27974 2.82533C7.31078 2.44545 7.37789 2.08879 7.54973 1.75153C7.81338 1.23408 8.23408 0.813385 8.75153 0.549733C9.08879 0.377889 9.44545 0.310778 9.82533 0.27974C10.1896 0.249981 10.6354 0.24999 11.1696 0.25ZM15.2252 2.94748C15.2434 3.16943 15.2482 3.4411 15.2495 3.80463C14.2331 3.44544 13.1394 3.25 12 3.25C10.8606 3.25 9.76687 3.44544 8.75047 3.80463C8.75176 3.44109 8.75662 3.16943 8.77476 2.94748C8.79822 2.66036 8.8401 2.52307 8.88624 2.43251C9.00608 2.19731 9.19731 2.00608 9.43251 1.88624C9.52307 1.8401 9.66035 1.79822 9.94748 1.77476C10.2434 1.75058 10.6276 1.75 11.2 1.75H12.8C13.3724 1.75 13.7566 1.75058 14.0525 1.77476C14.3396 1.79822 14.4769 1.8401 14.5675 1.88624C14.8027 2.00608 14.9939 2.19731 15.1138 2.43251C15.1599 2.52307 15.2018 2.66036 15.2252 2.94748ZM8.75 14C8.75 13.5858 8.41421 13.25 8 13.25C7.58578 13.25 7.25 13.5858 7.25 14C7.25 16.6234 9.37665 18.75 12 18.75C12.4142 18.75 12.75 18.4142 12.75 18C12.75 17.5858 12.4142 17.25 12 17.25C10.2051 17.25 8.75 15.7949 8.75 14Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M8 4.5V4.2C8 3.0799 8 2.51984 8.21799 2.09202C8.40973 1.71569 8.71569 1.40973 9.09202 1.21799C9.51984 1 10.0799 1 11.2 1H12.8C13.9201 1 14.4802 1 14.908 1.21799C15.2843 1.40973 15.5903 1.71569 15.782 2.09202C16 2.51984 16 3.0799 16 4.2V4.5M12 18C9.79086 18 8 16.2091 8 14M18 6.29168C16.4077 4.86656 14.3051 4 12 4C7.02944 4 3 8.02944 3 13C3 17.9706 7.02944 22 12 22C16.9706 22 21 17.9706 21 13C21 11.7586 20.7487 10.5759 20.2941 9.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M8 4.5V4.2C8 3.07989 8 2.51984 8.21799 2.09202C8.40973 1.71569 8.71569 1.40973 9.09202 1.21799C9.51984 1 10.0799 1 11.2 1H12.8C13.9201 1 14.4802 1 14.908 1.21799C15.2843 1.40973 15.5903 1.71569 15.782 2.09202C16 2.51984 16 3.07989 16 4.2V4.5M12 18C9.79086 18 8 16.2091 8 14M12 22V22C16.9706 22 21 17.9706 21 13V13C21 8.02944 16.9706 4 12 4V4C7.02944 4 3 8.02944 3 13V13C3 17.9706 7.02944 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M12 3.25C6.61522 3.25 2.25 7.61522 2.25 13C2.25 18.3848 6.61522 22.75 12 22.75C17.3848 22.75 21.75 18.3848 21.75 13C21.75 7.61522 17.3848 3.25 12 3.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.2 0.25H11.1696H11.1696C10.6354 0.24999 10.1896 0.249982 9.82533 0.27974C9.44545 0.310778 9.08879 0.377889 8.75153 0.549733C8.23408 0.813385 7.81339 1.23408 7.54973 1.75153C7.37789 2.08879 7.31078 2.44545 7.27974 2.82533C7.24998 3.18956 7.24999 3.6354 7.25 4.16955V4.16957V4.2V5C7.25 5.41422 7.58579 5.75 8 5.75C8.41421 5.75 8.75 5.41422 8.75 5V4.2C8.75 3.62757 8.75058 3.24336 8.77476 2.94748C8.79822 2.66036 8.8401 2.52307 8.88624 2.43251C9.00608 2.19731 9.19731 2.00608 9.43251 1.88624C9.52307 1.8401 9.66036 1.79822 9.94748 1.77476C10.2434 1.75058 10.6276 1.75 11.2 1.75H12.8C13.3724 1.75 13.7566 1.75058 14.0525 1.77476C14.3396 1.79822 14.4769 1.8401 14.5675 1.88624C14.8027 2.00608 14.9939 2.19731 15.1138 2.43251C15.1599 2.52307 15.2018 2.66036 15.2252 2.94748C15.2494 3.24336 15.25 3.62757 15.25 4.2V5C15.25 5.41422 15.5858 5.75 16 5.75C16.4142 5.75 16.75 5.41422 16.75 5V4.2V4.16955V4.16951C16.75 3.63538 16.75 3.18955 16.7203 2.82533C16.6892 2.44545 16.6221 2.08879 16.4503 1.75153C16.1866 1.23408 15.7659 0.813385 15.2485 0.549733C14.9112 0.377889 14.5546 0.310778 14.1747 0.27974C13.8104 0.249982 13.3646 0.24999 12.8305 0.25H12.8304H12.8H11.2ZM8.75 14C8.75 13.5858 8.41421 13.25 8 13.25C7.58579 13.25 7.25 13.5858 7.25 14C7.25 16.6234 9.37665 18.75 12 18.75C12.4142 18.75 12.75 18.4142 12.75 18C12.75 17.5858 12.4142 17.25 12 17.25C10.2051 17.25 8.75 15.7949 8.75 14Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
